
import React, { useCallback, useState, useEffect, forwardRef, useRef, useImperativeHandle } from "react";
import { TextField } from '@mui/material';
import { Controller } from "react-hook-form";
import { styled } from '@mui/material/styles';
import { IsNullOrEmpty } from "../../helpers/Common";

const FormTextarea = ({ rows, cols, value, limit, name, register, unregister, control, errors, setNoteContent, currentPageData, setCurrentPageData, clearErrors }) => {
    const [content, setContent] = useState(value.slice(0, limit));

    const setFormattedContent = useCallback(
        text => {
            setContent(text.slice(0, limit));
            if (text.length > 0) {
                errors[name] = null;
                clearErrors(name);
                // errors.noteContent = null;
                unregister(name);
            }
            const tempCurrentPageData = [...currentPageData];
            tempCurrentPageData[0][name] = text.slice(0, limit);
            setCurrentPageData(tempCurrentPageData);
            setNoteContent(text.slice(0, limit));
        },
        [limit, setContent]
    );
    const { ref, ...inputProps } = register(name, {
        required: "Content is required!"
    });
    useEffect(() => {
        if (content.length > 0) {
            clearErrors(name);
            errors[name] = null;
            // errors.noteContent = null;

        }
    }, [content]);

    return (
        <>
            <Controller
                name={name}
                control={control}
                render={({
                    field: { onChange, value = content },
                    fieldState: { error },
                    formState,
                }) => (
                    <TextField
                        helperText={error ? error.message : null}
                        error={!!error}
                        onChange={event => {
                            setFormattedContent(event.target.value);
                        }}
                        inputRef={ref}
                        value={value}
                        fullWidth
                        rows={rows}
                        cols={cols} multiline
                        InputProps={{ sx: { borderRadius: 5 } }}
                        variant="outlined"
                    />
                )}
            />
            <p style={{ marginTop: "10px" }}>
                {content.length}/Max Character Count:{limit}
            </p>
            {errors?.message && <span role="alert">{errors?.message}</span>}
        </>
    );
};

export default FormTextarea